import { render, staticRenderFns } from "./ResultView.vue?vue&type=template&id=467b6a7f&scoped=true&"
import script from "./ResultView.vue?vue&type=script&lang=js&"
export * from "./ResultView.vue?vue&type=script&lang=js&"
import style0 from "./ResultView.vue?vue&type=style&index=0&id=467b6a7f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467b6a7f",
  null
  
)

export default component.exports